import { render, staticRenderFns } from "./IgBlock.vue?vue&type=template&id=79785f28&"
import script from "./IgBlock.vue?vue&type=script&lang=js&"
export * from "./IgBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports